import styled from 'styled-components';

export const CreateAccountSubmitButtonContainer = styled.div`
  margin-top: auto;
  margin-bottom: 1rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    overflow: visible;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 4px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
